import React from "react";
import Link from "gatsby-link";
import GatsbyConfig from "../../../gatsby-config.js";
import { shuffle } from "../../utils/app-helpers";
import ReviewCard from "./review-card";

const { siteMetadata: config } = GatsbyConfig;

export default class ReviewsCallout extends React.Component {
  render() {
    const { trip } = this.props;
    const reviewCards = [];

    shuffle(config.reviews)
      .slice(0, 2)
      .forEach((review, key) => {
        reviewCards.push(
          <ReviewCard
            key={`review-card-${key}`}
            image={review.avatar}
            quote={review.quote.replace(/(<([^>]+)>)/gi, "")}
            cite={review.cite.replace(/(<([^>]+)>)/gi, "")}
          />
        );
      });

    return (
      <div className="reviews-callout">
        <div className="wrap">
          <h2>Testimonials</h2>
          <div className="review-cards">{reviewCards}</div>
          <Link className="btn btn-rounded" to={`/${trip}/reviews/`}>
            View All
            <i className="fa fa-external-link" />
          </Link>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/partials/reviews-callout.js